/* eslint-disable jsx-a11y/href-no-hash */
import React, { Component } from "react";
import { fromJS } from "immutable";
import { Left } from "react-bootstrap/lib/Media";
import './custom-grid.css';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import Swal from 'sweetalert2'
class CustomGrid extends Component {
    constructor(props) {
        super(props)
        this.populateActionColumn = this.populateActionColumn.bind(this);
        this.onPageChanged = this.onPageChanged.bind(this);
        this.localHandleRemoveClicked = this.localHandleRemoveClicked.bind(this);
        this.onPageClick = this.onPageClick.bind(this);

    }
 
    localHandleRemoveClicked(col) {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                this.props.handleRemoveClicked(col);
            }
        })
    }


    populateActionColumn(type, col, isAllowed, prop) {
        var allow = true;
        if (isAllowed !== undefined && isAllowed !== null) {
            allow = isAllowed;
        }
        if (type === 'View') {
            if (allow) {
                return (
                    <button className="action-icons text-success btn-trans btn-sm waves-effect" onClick={() => this.props.handleViewClicked(col)} >
                        <i className="material-icons">visibility  </i>
                    </button>
                );
            }
        } else if (type === 'Edit') {
            if (allow) {
                return (
                    <button className="action-icons text-warning btn-trans btn-sm waves-effect" onClick={() => this.props.handleEditClicked(col)} >
                        <i className="material-icons">edit  </i>
                    </button>
                );
            }
        } else if (type === 'Delete') {
            if (allow) {
                return (
                    <button className="action-icons text-danger btn-trans btn-sm waves-effect" onClick={() => this.localHandleRemoveClicked(col)} >
                        <i className="material-icons">delete  </i>
                    </button>
                );
            }
        }
        else if (type === 'Select') {
            if (allow !== null && allow === true && allow !== undefined) {
                return (
                    <button className="action-icons btn-trans btn-sm waves-effect" onClick={() => this.props.handleSelectRow(col)} >
                        <i className="material-icons">playlist_add_check</i>
                    </button>
                );
            }
        }
        else if (type === 'Custom') {
            if (allow !== null && allow === true && allow !== undefined) {
                return (
                    prop.map((x) => {
                        return this.renderCustomButton(x, col)
                    })
                );
            }
        }
        else if (type === 'Link') {

            if (allow !== null && allow === true && allow !== undefined) {
                return (
                    prop.map((x) => {
                        return this.renderHoverLink(x, col)
                    })
                );
            }
        }
        else if (type === 'Template') {
            if (allow !== null && allow === true && allow !== undefined) {
                return (
                    prop.map((x) => {
                        return this.renderHoverTemplate(x, col)
                    })
                );
            }
        }

    }

    renderCustomButton(x, col) {
        if (this.props.handleOnBindCustomAction(x.get('id'), col, this.props.isAdmin)) {
            if(x.get('id') == 'Split' || x.get('id') == 'Split2') {
                return (
                    <button title={x.get('label')} className={`${x.get('className')}`} onClick={() => this.props.handleCustomAction(x.get('id'), col)} >
                        <i className="material-icons" title={x.get('title')}>{x.get('icon')}</i> &nbsp; 
                        {x.get('label')}
                    </button>
                )
            } else {
                return (
                    <button title={x.get('label')} className={`btn-trans btn-sm waves-effect ${x.get('className')}`} onClick={() => this.props.handleCustomAction(x.get('id'), col)} >
                        <i className="material-icons" title={x.get('title')}>{x.get('icon')}</i> 
                        <div>{x.get('label')}</div>
                    </button>
                )
            }
        }
    }
    renderHoverLink(x, col) {
        if (this.props.handleOnBindCustomAction(x.get('id'), col, this.props.isAdmin)) {
            if (x.get('id') == 'Hover') {
                return (
                <Tooltip  title={
                    <React.Fragment>
                        <Typography variant="h6" color="inherit">Filter Params</Typography>
                        <hr/>
                    <Typography variant="h6" color="inherit">Client &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; : {col.get('client-name')}</Typography>
                    <Typography variant="h6" color="inherit">Division &nbsp;&nbsp;&nbsp;&nbsp;: {col.get('division-name')}</Typography>
                    <Typography variant="h6" color="inherit">Sender &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; : {col.get('request-data').get('sender-id')}</Typography>
                    <Typography variant="h6" color="inherit">Start Date : {col.get('request-data').get('start-date')}</Typography>
                    <Typography variant="h6" color="inherit">End Date &nbsp; : {col.get('request-data').get('end-date')}</Typography>
                  </React.Fragment>


                } >
                        <button>Hover Here</button>
                    </Tooltip>
                )
            } else if (x.get('id') == 'HoverTemplate') {

                return (
                    <Tooltip  title={
                        <React.Fragment>
                            <table>
                                <thead>
                                    <tr>
                                        <th colSpan={3} style={{borderBottom: '1px solid', textAlign: 'center'}}><Typography variant="h5" color="inherit">Template Detail</Typography></th>
                                    </tr>
                                </thead>
                                {col.get('messageDetail').map((data, i) => (
                                    <tbody style={{borderBottom: '1px solid'}}>
                                        <tr>
                                            <td style={{verticalAlign: 'top'}}><Typography variant="h6" color="inherit">No</Typography></td>
                                            <td style={{verticalAlign: 'top'}}><Typography variant="h6" color="inherit">&nbsp;:&nbsp;</Typography></td>
                                            <td style={{verticalAlign: 'top'}}><Typography variant="h6" color="inherit">{i + 1}</Typography></td>
                                        </tr>
                                        <tr>
                                            <td style={{verticalAlign: 'top'}}><Typography variant="h6" color="inherit">Language</Typography></td>
                                            <td style={{verticalAlign: 'top'}}><Typography variant="h6" color="inherit">&nbsp;:&nbsp;</Typography></td>
                                            <td style={{verticalAlign: 'top'}}><Typography variant="h6" color="inherit">{data.get('lang_code')}</Typography></td>
                                        </tr>
                                        <tr>
                                            <td style={{verticalAlign: 'top'}}><Typography variant="h6" color="inherit">Type</Typography></td>
                                            <td style={{verticalAlign: 'top'}}><Typography variant="h6" color="inherit">&nbsp;:&nbsp;</Typography></td>
                                            <td style={{verticalAlign: 'top'}}><Typography variant="h6" color="inherit">{data.get('type')}</Typography></td>
                                        </tr>
                                        <tr>
                                            <td style={{verticalAlign: 'top'}}><Typography variant="h6" color="inherit">Body</Typography></td>
                                            <td style={{verticalAlign: 'top'}}><Typography variant="h6" color="inherit">&nbsp;:&nbsp;</Typography></td>
                                            <td style={{verticalAlign: 'top'}}><Typography variant="h6" color="inherit">{data.get('raw_message')}</Typography></td>
                                        </tr>
                                        <tr>
                                            <td style={{verticalAlign: 'top'}}><Typography variant="h6" color="inherit">Footer</Typography></td>
                                            <td style={{verticalAlign: 'top'}}><Typography variant="h6" color="inherit">&nbsp;:&nbsp;</Typography></td>
                                            <td style={{verticalAlign: 'top'}}><Typography variant="h6" color="inherit">{data.get('raw_message_footer')}</Typography></td>
                                        </tr>
                                        <tr>
                                            <td style={{verticalAlign: 'top'}}><Typography variant="h6" color="inherit">Status</Typography></td>
                                            <td style={{verticalAlign: 'top'}}><Typography variant="h6" color="inherit">&nbsp;:&nbsp;</Typography></td>
                                            <td style={{verticalAlign: 'top'}}><Typography variant="h6" color="inherit">{data.get('statusTemplateName')}</Typography></td>
                                        </tr>
                                        {data.get('reasonFromFb') ? 
                                            <tr>
                                                <td><Typography variant="h6" color="inherit">Reason</Typography></td>
                                                <td><Typography variant="h6" color="inherit">&nbsp;:&nbsp;</Typography></td>
                                                <td><Typography variant="h6" color="inherit">{data.get('reasonFromFb')}</Typography></td>
                                            </tr>
                                        : null}
                                    </tbody>
                                ))}
                            </table>
                        </React.Fragment>


                    } >
                        <button>Hover Here</button>
                    </Tooltip>
                )
            }
        }

    }
    renderHoverTemplate(x, col) {
        if (this.props.handleOnBindCustomAction(x.get('id'), col, this.props.isAdmin)) {

        }
    }

    onPageChanged(event) {
        if (this.props.handlePageChanged !== undefined) {
            this.props.handlePageChanged(event.target.value);
        }
    }

    onPageClick(number) {
        if (this.props.handlePageChanged !== undefined) {
            this.props.handlePageChanged(number);
        }
    }

    _handleHeaderClicked(col) {
        this.props.handleHeaderClicked(col.field, col.sortId)
    }


    render() {
        var totalRow = this.props.items.get('row-count') !== undefined ? this.props.items.get('row-count') : 0;
        if (this.props.items.get('rows-count') != null) {
            totalRow = this.props.items.get('rows-count')
        }
        const pageCount = this.props.items.get('page-count') !== undefined ? this.props.items.get('page-count') : 0;
        const pageSize = this.props.items.get('page-size') !== undefined ? this.props.items.get('page-size') : 10;
        const curPage = this.props.items.get('page') !== undefined ? this.props.items.get('page') : 1;
        const items = (this.props.items.get('data') !== undefined ? this.props.items.get('data') : fromJS([]));
        const columns = (this.props.columns !== undefined ? this.props.columns : fromJS([]));
        const colSpan = columns.length;
       
        const prevPage = (curPage - 1) > 0 ? (curPage - 1) : 1;
        const nextPage = (curPage + 1) <= pageCount ? (curPage + 1) : curPage;
        const pages = [];

        if (curPage - 2 > 0) {
            pages.push(curPage - 2);
        }

        if (curPage - 1 > 0) {
            pages.push(curPage - 1);
        }

        pages.push(curPage);

        if (curPage + 1 <= pageCount) {
            pages.push(curPage + 1);
        }

        if (curPage + 2 <= pageCount) {
            pages.push(curPage + 2);
        }


        var First = <li className="page-item" onClick={() => this.onPageClick(1)}>
            <a className="page-link" href="#">
                First
                        </a>
        </li>

        var Last = <li className="page-item" onClick={() => this.onPageClick(pageCount)}>
            <a className="page-link" href="#">
                {`Last (${pageCount})`}
            </a>
        </li>

        if (pageCount == 0) {
            First = ""
            Last = ""
        }


        const allowSort = this.props.handleHeaderClicked !== undefined && this.props.sortForm !== undefined
        const sortForm = this.props.sortForm

        return (
            <div className="col-sm-12">
                <div className="table-responsive">
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                {
                                    columns.map((col) => {
                                        if (col.sortId !== undefined && allowSort) {
                                            var icon = ''
                                            if (sortForm.get('order-by') === col.sortId) {
                                                icon = <i className="material-icons">{sortForm.get('order') === 'ASC' ? 'arrow_drop_up' : 'arrow_drop_down'} </i>
                                            }
                                            return <th
                                                key={col.caption}
                                                style={{ cursor: "pointer" }}
                                                className={`${col.className} grid-header sortable`}
                                                onClick={() => this._handleHeaderClicked(col)}
                                            >
                                                <span >
                                                    {col.caption}
                                                    {icon}
                                                </span>
                                            </th>
                                        }
                                        return <th
                                            key={col.caption}
                                            className={`${col.className} grid-header`}
                                        >
                                            {col.caption}
                                        </th>
                                    })
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                items.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            {
                                                // eslint-disable-next-line array-callback-return
                                                columns.map((col, idxCol) => {
                                                   
                                                    if (col.cfield) {
                                                        if (col.cfield === 'action') {
                                                            return (
                                                                <td key={"action" + index + idxCol} className={col.className}>
                                                                    {
                                                                        this.populateActionColumn("Edit", item, col.allowEdit)
                                                                    }
                                                                    {
                                                                        this.populateActionColumn("Delete", item, col.allowDelete)
                                                                    }
                                                                    {
                                                                        this.populateActionColumn("View", item, col.allowView)
                                                                    }
                                                                    {
                                                                        this.populateActionColumn("Select", item, col.allowSelect !== undefined ? col.allowSelect : false)
                                                                    }
                                                                    {
                                                                        this.populateActionColumn("Custom", item, col.custom !== undefined && col.custom.size > 0 ? true : false, col.custom)
                                                                    }
                                                                    {
                                                                        this.populateActionColumn("Link", item, col.link !== undefined && col.link.size > 0 ? true : false, col.link)
                                                                    }

                                                                </td>
                                                            );
                                                        } else if (col.cfield === 'counter') {
                                                            return (
                                                                <td key={"counter" + index} className={col.className}>
                                                                    {((curPage - 1) * pageSize) + (index + 1)}
                                                                </td>
                                                            );
                                                        } else if (col.cfield === 'icon') {
                                                            return (
                                                                <td key={col.field + index + idxCol} className={col.className}>
                                                                    {this.props.handleCustomIcon(item)}
                                                                </td>
                                                            )
                                                            
                                                        }
                                                    } else {
                                                        return (
                                                          <td
                                                            key={col.field}
                                                            className={
                                                              col.className
                                                            }
                                                            style={{
                                                              whiteSpace: 'pre',
                                                            }}
                                                          >
                                                            {' '}
                                                            {item.get(
                                                              col.field
                                                            )}{' '}
                                                          </td>
                                                        )
                                                    }
                                                })
                                            }
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={colSpan} className="text-center">
                                    <nav aria-label="Page navigation example">
                                        <ul className="pull-left">
                                        <div className="content_total">Total : {totalRow} row</div> 
                                        </ul>
                                        <ul className="pagination pull-right">
                                            {First}
                                            {
                                                pages.map((number) => {
                                                    var style = 'page-item'
                                                    if (number === curPage) {
                                                        style += ' active'
                                                    }
                                                    if (number != -1) {
                                                        return (
                                                            <li key={number} className={style} onClick={() => this.onPageClick(number)} >
                                                                <a className="page-link" href="#">{number}</a>
                                                            </li>
                                                        )
                                                    } else {
                                                        return (
                                                            <li key={number} className="page-item disbale" >
                                                                <a className="page-link" href="#" >...</a>
                                                            </li>
                                                        )
                                                    }

                                                })
                                            }
                                            {Last}
                                        </ul>
                                    </nav>
                                </td>
                            </tr>
                        </tfoot>
                    </table>

                </div>
            </div>
        );
    }
}

export default (CustomGrid);